import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(date) {
  if (!date) return '';
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelativeTime(date) {
  if (!date) return '';
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(date);
}

export function getSessionTypeLabel(type) {
  const labels = {
    personal_training: 'Personal Training',
    group_class: 'Group Class',
    assessment: 'Assessment',
    rehabilitation: 'Rehabilitation',
    strength: 'Strength',
    cardio: 'Cardio',
    flexibility: 'Flexibility',
    custom: 'Custom',
  };
  return labels[type] || type;
}

export function getStatusColor(status) {
  const colors = {
    pending: 'badge-warning',
    confirmed: 'badge-success',
    cancelled: 'badge-danger',
    no_show: 'badge-danger',
    approved: 'badge-success',
    rejected: 'badge-danger',
    fulfilled: 'badge-info',
    open: 'badge-warning',
    reviewed: 'badge-info',
    dismissed: 'badge-secondary',
  };
  return colors[status] || 'badge-info';
}
